import * as React from 'react';
const SvgChevronLeft = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 13 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M13 17.151 10.101 20 0 10.009 10.101 0l2.864 2.815L5.65 10z" />
  </svg>
);
export default SvgChevronLeft;
